/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  BG_IMG_1,
  Creative_fab,
  Fabric_icon,
  Frame_icon,
  Half_circle,
  Line_wave,
  People_icon,
  Rectangle_dots,
  Red_Dots,
  Red_arrow,
  Ring_circle,
  Slider_img_1,
  Slider_img_2,
  Slider_img_3,
  Slider_img_4,
  Spring_arrow,
  Squre_Red_Dots,
  Wave_icon,
  home_Left,
  home_Right,
  home_image,
} from "../../helper/imageConstant";
import { IoIosArrowRoundForward } from "react-icons/io";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import ContactUs from "../ContactUs/ContactUs";
import { NavLink } from "react-router-dom";
import BottomButton from "../../components/common/bottomButton/BottomButton";

const imgData = [
  {
    no: "01",
    name: "Printed Fabrics",
    img: Slider_img_1,
  },
  { no: "02", name: "Satin", img: Slider_img_2 },
  { no: "03", name: "Georgette", img: Slider_img_3 },
  { no: "04", name: "Textured Tussar Silk", img: Slider_img_4 },
];
const maxNameLength = Math.max(...imgData.map((data) => data.name.length));

export const Home = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const [isButtonInContact, setIsButtonIncontact] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const button = document.getElementById("your-button-id");
      const contact = document.getElementById("your-contact-id");

      if (button && contact) {
        const buttonRect = button.getBoundingClientRect();
        const contactRect = contact.getBoundingClientRect();

        const buttonIncontact = buttonRect.bottom > contactRect.top;

        setIsButtonIncontact(buttonIncontact);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const buttonStyle = {
    backgroundColor: isButtonInContact ? "#fff0f0" : "",
    Color: isButtonInContact ? "#A5302E" : "#fff",
    border: isButtonInContact ? "2px solid #fff" : "",
    Zindex: isButtonInContact ? "50" : "",
  };
  return (
    <>
      <section className="relative pl-0 lg:pl-0 p-4">
        <div className="4xl:max-w-[1920px] mx-auto">
          <div className="absolute top-6 right-5 lg:right-2 xl:top-16 xl:right-4 2xl:right-6 3xl:right-11">
            <img
              src={Red_Dots}
              alt=""
              className="w-16 sm:w-24 lg:w-24 xl:w-24 2xl:w-28 3xl:w-full"
            />
          </div>
          <div className="lg:hidden my-10 px-5">
            <div className="fab_font lg:absolute top-12 left-5 lg:top-10 lg:left-2 xl:top-18 xl:left-14 2xl:left-14 4xl:top-[6rem]  z-20">
              <h2
                className="text-7xl sm:text-[7rem] lg:text-[8rem] xl:text-[9.5rem] 2xl:text-[11rem]
             4xl:text-[13.5rem] leading-none text-[#A5302E]"
              >
                FABRIC
              </h2>
              <div className="bg-[#f6dddd] w-full h-2.5 hidden lg:block"></div>
            </div>
            <div className="lg:absolute top-28 left-5 lg:top-[7.5rem] lg:left-[50%] xl:top-[9rem] 2xl:top-[9rem] 2xl:left-[49.5%] 4xl:top-[18.5%] 4xl:left-[49.5%] z-20">
              <h2 className="text-7xl sm:text-[7rem] lg:text-[8rem] xl:text-[9.5rem] 2xl:text-[11.5rem] 4xl:text-[13.5rem] text-[#A5302E] font-medium text-shadow">
                FUSION
              </h2>
            </div>
          </div>
          <div className="lg:mt-48 xl:mt-64 4xl:mt-96 w-full grid grid-cols-6 lg:grid-cols-12 gap-4 lg:gap-10">
            <div className="col-span-2 lg:col-span-3 flex flex-col justify-end ">
              <div className="pl-2 md:pl-4 lg:pl-6 mt-3 lg:mt-5 2xl:mt-0 lg:mb-5">
                <p className="text-[6.5px] sm:text-sm lg:text-[10px] 2xl:text-[12.5px] 3xl:text-xl 4xl:text-[15px] leading-relaxed sm:leading-loose lg:leading-6 xl:leading-8 2xl:leading-9 4xl:leading-10 uppercase break-words font-normal">
                  Welcome to VikasFashion, Step into a world where innovation,
                  timeless elegance, creativity converge, offering you a unique
                  and unparalleled textile experience
                </p>
              </div>
              <div className="mt-2">
                <div className="w-full">
                  <img src={home_Left} alt={""} className="object-cover" />
                </div>
              </div>
            </div>
            <div className="col-span-4 lg:col-span-7 text-center flex justify-center relative">
              <div className="mb-8 lg:mb-14">
                <img
                  src={home_image}
                  alt={""}
                  className="w-full h-full object-fill"
                />
              </div>
              <div className="hidden lg:contents my-10 lg:mt-48 xl:mt-60 2xl:mt-[16.5rem] 4xl:mt-96 px-5">
                <div
                  className=" fab_font lg:absolute top-12 left-5 lg:-top-[32%] 
                lg:-left-[38%] xl:-top-[35%] xl:-left-[38%] 2xl:-top-[34%] 2xl:-left-[34%] 4xl:-top-[37%] 4xl:-left-[37.5%] z-20"
                >
                  <h2
                    className="text-7xl sm:text-[7rem] lg:text-[7.5rem] xl:text-[9.5rem] 2xl:text-[10.5rem]
             4xl:text-[13.5rem] leading-none text-[#A5302E]"
                  >
                    FABRIC
                  </h2>
                  <div className="bg-[#f6dddd] w-full h-2.5 hidden lg:block"></div>
                </div>
                <div
                  className="lg:absolute top-28 left-5 lg:-top-[16.5%] lg:left-[44%]
                 xl:-top-[17.5%] xl:left-[42%] 2xl:-top-[17%] 2xl:left-[46.5%] 4xl:-top-[18.5%] 4xl:left-[42.5%] z-20"
                >
                  <h2
                    className="text-7xl sm:text-[7rem] lg:text-[7.5rem] xl:text-[9.5rem]
                   2xl:text-[10.5rem] 4xl:text-[13.5rem] text-[#A5302E] font-medium text-shadow"
                  >
                    FUSION
                  </h2>
                </div>
              </div>
              <div className="absolute bottom-0">
                <div className="bg-[#A5302E] w-6 lg:w-10 h-1 lg:h-2"></div>
              </div>
            </div>
            <div className="lg:col-span-2 hidden lg:flex flex-col justify-center items-center lg:justify-end">
              <div className="">
                <div className="sm:h-full lg:h-full w-full">
                  <img
                    src={home_Right}
                    alt={""}
                    className="w-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w-full relative p-4 border border-b-[#D1ABAB] border-transparent">
        <div className="mt-10 md:mx-auto xl:max-w-[56rem] 2xl:max-w-[65.5rem] 3xl:max-w-7xl flex justify-center relative">
          <div className="lg:p-5 lg:mb-10">
            <div className="grid grid-cols-12 gap-2 mb-10 md:mb-16 xl:mb-10">
              <div className="col-span-12 lg:col-span-6 relative">
                <div className="mb-5">
                  <NavLink
                    to={"/about-us"}
                    onClick={scrollToTop}
                    className="p-2 text-white bg-[#A5302E] text-xs 2xl:text-sm font-bold uppercase"
                  >
                    About Us
                  </NavLink>
                </div>
                <div className="w-full lg:pr-28 2xl:pr-5 3xl:pr-28 lg:mb-32 3xl:mb-5">
                  <h1
                    className="pr-24 xs:pr-14 md:pr-[19rem] lg:pr-0 mb-2 text-xl xs:text-[28px] leading-normal md:text-4xl lg:text-3xl 2xl:text-4xl 3xl:text-[42px]
                   md:leading-normal lg:leading-10 xl:leading-10 2xl:leading-tight 3xl:leading-tight font-normal"
                  >
                    Discover Our{" "}
                    <span className="text-[#A5302E]">Fabric Story: </span>
                    Crafting Excellence, One Thread at a Time.
                  </h1>
                </div>
                <div className="absolute right-0 bottom-2 xs:bottom-5 lg:right-16 lg:bottom-10">
                  <img
                    src={Squre_Red_Dots}
                    alt=""
                    className="w-10 md:w-14 lg:w-14"
                  />
                </div>
              </div>
              <div className="col-span-12 lg:col-span-6 flex justify-start">
                <div className="text-justify text-sm xs:text-base md:text-lg lg:text-lg xl:text-lg 2xl:text-lg 3xl:text-[22px] pr-8 lg:pr-4 leading-normal font-normal">
                  <p className="mb-6 leading-relaxed lg:leading-loose 3xl:leading-loose tracking-wide ">
                    Explore the legacy of quality at Vikas Fashion, where we
                    have been crafting excellence for a years. We offer a
                    diverse range of meticulously selected fabrics, all with
                    your creative vision in mind.{" "}
                  </p>
                  <p className=" leading-relaxed lg:leading-loose 3xl:leading-loose">
                    Experience our commitment to both tradition and innovation
                    as we provide you with the finest materials for your
                    projects.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 xs:mt-8 lg:mt-10 xl:mt-14">
              <div className="grid grid-cols-6 lg:grid-cols-12 gap-y-20 mx-auto">
                <div className="col-span-3 lg:col-span-3 flex justify-center items-center border-r-[#D1ABAB] border-r">
                  <div className="lg:border-right-red xl:gap-5 py-3 space-y-5 md:space-y-6 2xl:space-y-8">
                    <div>
                      <img src={Frame_icon} alt="" />
                    </div>
                    <div className="">
                      <h1 className="text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-3xl font-medium">
                        Fabric <br /> Passion
                      </h1>
                    </div>
                    <div className="flex items-center gap-2">
                      <IoIosArrowRoundForward className="text-4xl xl:text-2xl 2xl:text-4xl text-[#A5302E]" />
                    </div>
                  </div>
                </div>
                <div className="col-span-3 lg:col-span-3 flex justify-center items-center lg:border-r-[#D1ABAB] lg:border-r">
                  <div className="lg:border-right-red xl:gap-5 py-3 space-y-5 md:space-y-6 2xl:space-y-8">
                    <div>
                      <img src={Wave_icon} alt="" />
                    </div>
                    <div className="">
                      <h1 className="text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-3xl font-medium">
                        Legacy <br /> Weave
                      </h1>
                    </div>
                    <div className="flex items-center gap-2">
                      <IoIosArrowRoundForward className="text-4xl xl:text-2xl 2xl:text-4xl text-[#A5302E] " />
                    </div>
                  </div>
                </div>
                <div className="col-span-3 lg:col-span-3 flex justify-center items-center border-r-[#D1ABAB] border-r">
                  <div className="lg:border-right-red xl:gap-5 py-3 space-y-5 md:space-y-6 2xl:space-y-8">
                    <div>
                      <img src={Fabric_icon} alt="" />
                    </div>
                    <div className="">
                      <h1 className="text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-3xl font-medium">
                        Fabric <br /> Elegance
                      </h1>
                    </div>
                    <div className="flex items-center gap-2">
                      <IoIosArrowRoundForward className="text-4xl xl:text-2xl 2xl:text-4xl text-[#A5302E]" />
                    </div>
                  </div>
                </div>
                <div className="col-span-3 lg:col-span-3 flex justify-center items-center">
                  <div className="lg:border-right-red xl:gap-5 py-3 space-y-5 md:space-y-6 2xl:space-y-8">
                    <div>
                      <img src={People_icon} alt="" />
                    </div>
                    <div className="">
                      <h1 className="text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-3xl font-medium">
                        Customer <br /> Crafted
                      </h1>
                    </div>
                    <div className="flex items-center gap-2">
                      <IoIosArrowRoundForward className="text-4xl xl:text-2xl 2xl:text-4xl text-[#A5302E]" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="red_arrow absolute top-[26.5rem] right-4 xs:top-[29rem] xs:right-8 md:top-[28rem] md:right-6 lg:top-[13rem] lg:right-6 3xl:right-20">
          <img src={Red_arrow} alt="" className="w-3 md:w-4 lg:w-5" />
        </div>
        <div
          className="absolute bottom-56  xs:bottom-56 xs:left-[43.3%] md:bottom-60 md:left-[46.2%]
         lg:bottom-96 lg:left-8 2xl:top-[17rem] 2xl:left-20 3xl:left-28 red_spring_arrow"
        >
          <img src={Spring_arrow} alt="" className="w-20 xl:w-28 2xl:w-32" />
        </div>
      </section>
      <section className="relative overflow-hidden z-0">
        <div className="mt-14">
          <div className="text-center mb-16 p-2">
            <h2 className="text-[#A5302E] text-2xl xs:text-[28px] md:text-4xl lg:text-[40px] font-medium uppercase">
              most popular products
            </h2>
          </div>
          <div className="content my-5">
            <div className="grid grid-col-2 md:grid-cols-2 lg:grid-cols-4">
              {imgData.map((data, i) => (
                <div key={i} className="w-full relative group">
                  <div className="h-full w-full z-50">
                    <img src={data?.img} alt="" className="object-cover" />
                    <div className="absolute h-full w-full bg-black/20 flex items-center justify-center group-hover:bottom-0 opacity-0 group-hover:opacity-100"></div>
                  </div>
                  <div
                    className={`block absolute bottom-10  3xl:bottom-8 z-50`}
                  >
                    <div
                      style={{ width: `${maxNameLength * 15}px` }}
                      className="p-2 px-4 text-[#ffffff] bg-[#A5302E] text-2xl xl:text-2xl 3xl:text-2xl"
                    >
                      {data?.name}
                    </div>
                  </div>
                  <div className="absolute top-7 left-10 group-hover:-top-7">
                    <span className="group-hover:bg-[#A5302E] group-hover:text-[#ffffff] text-white text-3xl py-3 px-2.5 flex items-center justify-center rounded-full fonts">
                      {data?.no}.
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="relative overflow-hidden">
        <div className="4xl:max-w-[1920px] mx-auto lg:max-w-xl xl:max-w-2xl 2xl:max-w-[51rem] 3xl:max-w-[1800px] lg:my-10 xl:my-20 pb-10 lg:pb-10 xl:pb-16 2xl:pb-36 p-4">
          <div className="grid grid-cols-6 lg:grid-cols-12">
            <div className="col-span-6 lg:col-span-12">
              <div className="flex justify-center items-center">
                <div className="relative">
                  <div
                    className="lg:absolute lg:-left-[35.5%] lg:top-[2%] xl:-top-[3%] xl:-left-[39.5%] 2xl:-top-[2%] 2xl:-left-[18%]
          3xl:-left-[64%] 3xl:-top-[5%] top-2 lg:bg-[#fff0f0] lg:p-4 lg:pr-0 xl:pr-14 2xl:pr-0 3xl:pr-8 flex flex-col lg:gap-2 xl:gap-3.5 mb-5 lg:mb-0 lg:pb-4 xl:pb-14 3xl:pb-12 2xl:pt-2"
                  >
                    <div className="flex flex-col gap-2 xs:gap-4 lg:gap-3 3xl:gap-5">
                      <h2
                        className="text-[#A5302E] text-4xl xs:text-4xl md:text-6xl lg:text-2xl 
                        xl:text-4xl 2xl:text-3xl 3xl:text-4xl lg:w-[22rem] xl:w-[23rem] 2xl:w-80 3xl:w-[28rem] italic font-medium lg:mb-0 pr-5 xs:pr-14 lg:pr-24 xl:pr-0 3xl:pr-14 leading-tight 2xl:leading-tight 3xl:leading-tight"
                      >
                        Innovating Fabrics: Our Achievements
                      </h2>
                      <p className="lg:w-80 xl:w-96 2xl:w-[25rem] 3xl:w-[28rem] text-xs xs:text-base md:text-2xl lg:text-xs xl:text-sm 2xl:text-sm 3xl:text-base leading-5  xs:leading-6 md:leading-9 3xl:leading-7 font-normal md:pr-0 ">
                        Unveiling Our Fabric Excellence: Quality, Space, Reach,
                        and Production – We are Committed to Your Success.
                      </p>
                      <div className="">
                        <button
                          className="py-2 px-4 md:py-3.5 md:px-6 lg:py-2 lg:px-4 3xl:py-3 3xl:px-8
                 text-xs md:text-base lg:text-sm 3xl:text-base text-left bg-[#A5302E] text-[#fff]"
                        >
                          Learn More
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="3xl:w-[550px] my-10 lg:my-0 mx-8 sm:mx-16 md:mx-20 lg:mx-[70px] 2xl:mx-[150px] 3xl:mx-0 ">
                    <img
                      src={BG_IMG_1}
                      alt=""
                      className="xl:w-full h-full rounded-full"
                    />
                  </div>
                  <div
                    className="Ring_circle_img absolute -bottom-[0%] left-[4%] xs:bottom-[27.2%] xs:left-[2%] sm:bottom-[24%] sm:left-[0%] md:bottom-[31%] md:left-[5%]
                 lg:-bottom-[5%] lg:-left-[4%] xl:-bottom-[5.5%] xl:-left-[7%] 2xl:-bottom-[8.5%] 2xl:left-[5%]
                  3xl:-bottom-[11%] 3xl:-left-[24%]"
                  >
                    <div className="w-20 xs:w-36 sm:w-56 md:w-64 lg:w-48 xl:w-[15rem] 2xl:w-60 3xl:w-72 h-full">
                      <img src={Ring_circle} alt="" className="object-cover" />
                    </div>
                  </div>
                  <div
                    className="mt-5 md:mt-8 lg:absolute lg:-bottom-[0] lg:-right-[35.5%] xl:bottom-[1%] xl:-right-[45%]
           2xl:-bottom-2 2xl:-right-[27.5%] 3xl:bottom-0 3xl:-right-[68%] z-40"
                  >
                    <div className="grid grid-cols-2 gap-4 3xl:gap-5">
                      <span className="bg-[#A5302E] p-4 md:p-8 lg:py-7 lg:px-2 xl:py-8 xl:px-4 2xl:py-[34px] 2xl:px-4 3xl:py-10 3xl:px-2.5">
                        <span className="text-center flex flex-col justify-center items-center gap-2 md:gap-4 lg:gap-2 text-[#fff]">
                          <h3 className="text-2xl md:text-5xl lg:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl fonts font-medium">
                            100%
                          </h3>
                          <p className="text-xs md:text-xl lg:text-sm xl:text-lg 2xl:text-lg 3xl:text-xl font-normal fonts">
                            Quality Product
                          </p>
                        </span>
                      </span>
                      <span className="bg-[#A5302E] p-4 md:p-8 lg:py-7 lg:px-2 xl:py-8 xl:px-4 2xl:py-[34px] 2xl:px-4 3xl:py-10 3xl:px-2.5">
                        <span className="text-center flex flex-col justify-center items-center gap-2 md:gap-4 lg:gap-2 text-[#fff]">
                          <h3 className="text-2xl md:text-5xl lg:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl fonts font-medium">
                            29,952+
                          </h3>
                          <p className="text-xs md:text-xl lg:text-sm xl:text-lg 2xl:text-lg 3xl:text-xl font-normal fonts">
                            Square Feet of Space
                          </p>
                        </span>
                      </span>
                      <span className="bg-[#A5302E] p-4 md:p-8 lg:py-7 lg:px-2 xl:py-8 xl:px-4 2xl:py-[34px] 2xl:px-4 3xl:py-10 3xl:px-2.5">
                        <span className="text-center flex flex-col justify-center items-center gap-2 md:gap-4 lg:gap-2 text-[#fff]">
                          <h3 className="text-2xl md:text-5xl lg:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl fonts font-medium">
                            24,957+
                          </h3>
                          <p className="text-xs md:text-xl lg:text-sm xl:text-lg 2xl:text-lg 3xl:text-xl font-normal fonts">
                            Customers Already Served
                          </p>
                        </span>
                      </span>
                      <span className="bg-[#A5302E] p-4 md:p-8 lg:py-7 lg:px-2 xl:py-8 xl:px-4 2xl:py-[34px] 2xl:px-4 3xl:py-10 3xl:px-2.5">
                        <span className="text-center flex flex-col justify-center items-center gap-2 md:gap-4 lg:gap-2 text-[#fff]">
                          <h3 className="text-2xl md:text-5xl lg:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl fonts font-medium">
                            5,96,403
                          </h3>
                          <p className="text-xs md:text-xl lg:text-sm xl:text-lg 2xl:text-lg 3xl:text-xl font-normal fonts">
                            Units Dispatched Monthly
                          </p>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block absolute top-12 right-0">
            <div className="lg:w-28 xl:w-36 3xl:w-48 h-full">
              <img src={Line_wave} alt="" className="object-cover" />
            </div>
          </div>
        </div>
      </section>
      <ContactUs homeContact contactUs={false} id={"your-contact-id"} />
      <section className="p-8 lg:py-28 relative overflow-hidden">
        <div className="mx-auto lg:max-w-[778px] xl:max-w-[960px] 3xl:max-w-[1200px] lg:mb-10">
          <div className="md:mt-5 lg:mt-5 grid grid-cols-6 lg:grid-cols-12 lg:gap-20 xl:gap-24 3xl:gap-28">
            <div className="col-span-6 lg:col-span-6 order-2 lg:order-1">
              <div className="relative">
                <div className="lg:w-[430px] lg:h-[430px] 3xl:w-full 3xl:h-full mr-10 md:mr-16">
                  <img
                    src={Creative_fab}
                    alt=""
                    className="mx-auto object-cover"
                  />
                </div>
                <div
                  className="absolute -top-7 left-[5%] md:-top-7 md:left-[15%] lg:-top-[5%] lg:left-[9.5%] xl:-top-[4.50%] xl:left-[10.5%]
                 2xl:bottom-[8%] 2xl:left-[10.5%] 3xl:-top-[8%] 3xl:left-[10%] 4xl:-top-[4%] 4xl:left-[10%]"
                >
                  <div className="flex items-center bg-black py-4 px-2 lg:py-5 lg:px-3 text-base lg:text-lg text-white rounded-[50%]">
                    <MdOutlineArrowBackIos />
                    <MdOutlineArrowForwardIos />
                  </div>
                </div>
                <div className="lg:hidden absolute -bottom-0 -right-0 md:bottom-1 md:right-14">
                  <div className="bg-[#000] py-4 px-6 md:py-12 md:px-14">
                    <p
                      className="text-[#fff] text-center text-[22px] md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-2xl
                     italic break-words flex flex-col lg:gap-2"
                    >
                      Your creative <span>fabric</span>
                      <span>destination.</span>
                    </p>
                  </div>
                </div>
                <div
                  className="hidden lg:block absolute lg:-bottom-[15.5%] lg:-right-[14%]
                 xl:-bottom-[24%] xl:right-[2%] 2xl:-bottom-[24.5%] 2xl:-right-[4%] 3xl:bottom-0 3xl:-right-[9%]"
                >
                  <div className="bg-[#000] lg:p-8 xl:px-10 xl:py-8 2xl:px-14 2xl:py-8 3xl:px-14 3xl:py-11">
                    <p
                      className="text-[#fff] text-center lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-3xl
                     italic break-words flex flex-col lg:gap-2"
                    >
                      Your creative <span>fabric</span>
                      <span>destination.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="absolute top-[6%] right-[35%] xs:top-[5.5%] xs:right-[32%] md:top-[5%] md:right-[38%] lg:top-[16.5%] lg:left-[7%] xl:top-[21.5%] xl:left-[2.5%]
             2xl:top-[15.5%] 2xl:left-[13.5%] 3xl:top-[12%] 3xl:left-[15%]"
            >
              <div className="w-3 md:w-5 lg:w-5 xl:w-5 2xl:w-6 3xl:w-10 h-full">
                <img
                  src={Red_arrow}
                  alt=""
                  className="object-cover max-w-full mx-auto rotate-180"
                />
              </div>
            </div>
            <div
              className="absolute top-[2%] right-[6%] lg:top-[15.5%] lg:left-[55.5%] xl:top-[22.5%] xl:left-[48%]
             2xl:top-[14.5%] 2xl:left-[50%] 3xl:top-[10%] 3xl:left-[50%]"
            >
              <div className="w-7 md:w-9 lg:w-10 xl:w-12 2xl:w-14 4xl:w-16 h-full">
                <img
                  src={Half_circle}
                  alt=""
                  className="object-cover max-w-full mx-auto"
                />
              </div>
            </div>
            <div
              className="absolute top-[11%] -right-[9%] md:-right-[5%] lg:top-[10%] lg:right-[4%] xl:top-[10%] xl:right-[3%]
             2xl:top-[8%] 2xl:right-[2.5%] 4xl:top-[8.5%] 4xl:right-[2.5%]"
            >
              <div className="w-14 md:w-16 lg:w-32 2xl:w-28 4xl:w-40 h-full">
                <img
                  src={Rectangle_dots}
                  alt=""
                  className="object-cover max-w-full mx-auto"
                />
              </div>
            </div>
            <div
              className="absolute top-[30%] right-[5%] xs:top-[28%] xs:right-[5%] md:top-[25%] md:right-[5%] lg:top-[75%] lg:-left-[5%] xl:top-[85.5%] xl:-left-[5%]
             2xl:top-[75.5%] 2xl:-left-[3%] 3xl:top-[70%]"
            >
              <div className="w-24 md:w-28 lg:w-32 2xl:w-36 4xl:w-44 h-full">
                <img
                  src={Rectangle_dots}
                  alt=""
                  className="object-cover max-w-full mx-auto"
                />
              </div>
            </div>
            <div className="col-span-6 lg:col-span-6 flex justify-start items-start order-1 lg:order-1">
              <div className="mt-5 lg:mt-0 mb-10 lg:mb-0 w-full lg:px-4 flex flex-col gap-5 lg:gap-5">
                <div className="">
                  <span
                    className="py-2 px-3 sm:py-2 sm:px-2 bg-[#A5302E] text-white text-xs xs:text-sm md:text-base
                   lg:text-xs xl:text-sm uppercase leading-none"
                  >
                    Luxurious Fabric
                  </span>
                </div>
                <div className="">
                  <h3
                    className="text-[#A5302E] text-3xl xs:text-[40px] md:text-5xl  2xl:text-[42px] flex flex-wrap leading-tight xl:leading-snug lg:pr-0
                   lg:text-[40px] xl:text-6xl 3xl:text-6xl font-medium italic"
                  >
                    Discover Our <br className="" /> Fabric Collections
                  </h3>
                </div>
                <p className="text-[#000] text-base xs:text-base md:text-lg  3xl:text-xl leading-relaxed 3xl:leading-relaxed xs:pr-5 md:pr-48 lg:pr-0 xl:pr-0">
                  Explore our thoughtfully curated fabric collections, perfect
                  for all your creative pursuits.
                </p>
                <ul className="list-disc pl-5 text-base xs:text-xl md:text-lg 3xl:text-xl">
                  <li className="py-2 text-[#555555] hover:text-[#A5302E]">
                    <h4 className="">Silk Sensations</h4>
                  </li>
                  <li className="py-2 text-[#555555] hover:text-[#A5302E]">
                    <h4 className="">Cotton Comfort</h4>
                  </li>
                  <li className="py-2 text-[#555555] hover:text-[#A5302E]">
                    <h4 className="">Denim Classics</h4>
                  </li>
                  <li className="py-2 text-[#555555] hover:text-[#A5302E]">
                    <h4 className="">Linen Elegance</h4>
                  </li>
                  <li className="py-2 text-[#555555] hover:text-[#A5302E]">
                    <h4 className="">Shaded Chiffon</h4>
                  </li>
                </ul>
              </div>
            </div>
            <div className="hidden lg:block absolute lg:bottom-16 lg:-right-[13%] xl:bottom-14 xl:-right-[10%]  3xl:bottom-28 3xl:-right-[12%]">
              <div className="lg:w-60 xl:w-[17rem] 3xl:w-full h-full">
                <img src={Ring_circle} alt="" className="opacity-30" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <BottomButton id={"your-button-id"} buttonStyle={buttonStyle} />
    </>
  );
};

export default Home;
